import axios from 'axios';

// import { isSignedIn, signOut } from '_state/auth/fns';
// import { HttpStatus } from '_enums';
import { isAxiosError, isFormData } from '_utils/axios';
// import { redirect } from '_utils/router';
import config from "../config";
import { AuthService } from "_services/auth.service";
import { HttpStatus } from "_enums/HttpStatus";
import { toastError } from "_components/ToastProvider";
import { ErrorCodeInfo } from "_enums/ErrorCode";

export const api = axios.create({
    baseURL: config.API_URL + '/api/v1'
});

api.defaults.headers.common['Accept'] = 'application/json';
api.defaults.headers.common['Content-Type'] = 'application/json';

// api.patch = (url, data, config) => {
//     if (data) {
//         if (isFormData(data)) {
//             data.append('_method', 'PATCH');
//
//         else if (typeof data === 'object') {
//             data = { ...data, _method: 'PATCH' };
//         }
//     }
//
//     return api.post(url, data, config);
// };

api.patchForm = (url, data, config) => {
    if (data) {
        if (isFormData(data)) {
            data.append('_method', 'PATCH');
        } else if (typeof data === 'object') {
            data = { ...data, _method: 'PATCH' };
        }
    }

    return api.postForm(url, data, config);
};

api.interceptors.request.use(config => {
    if (AuthService.isLoggedIn()) {
        config.headers.Authorization = `Bearer ${AuthService.token}`;
        config.headers.Accept = 'application/json';
    }

    return config;
});

api.interceptors.response.use(undefined, err => {
    if (
        isAxiosError(err)
        && (err.response?.status === HttpStatus.UNAUTHORIZED)
        && AuthService.isLoggedIn()
        && !AuthService.requiresTwoFactor
        && !AuthService.registering2FA
    ) {
        toastError('Sua sessão expirou. Por favor, faça login novamente.', 'Sessão expirada ⛔');
        AuthService.logout();
        setTimeout(() => window.location.reload(), 3000);
        return;
    }

    if (
        isAxiosError(err)
        && (err.response?.status === HttpStatus.FORBIDDEN)
        && AuthService.isLoggedIn()
    ) {
        if (AuthService.requiresTwoFactor) {
            if (window.location.pathname !== '/admin/two-factor') {
                setTimeout(() => (window.location.pathname = '/admin/two-factor'), 5000);
                return;
            }
            return;
        }

        toastError(ErrorCodeInfo[HttpStatus.FORBIDDEN].description, ErrorCodeInfo[HttpStatus.FORBIDDEN].title);
        setTimeout(() => (window.location.pathname = '/admin'), 5000)
    }

    throw err;
});
